import { render, staticRenderFns } from "./rankingList.vue?vue&type=template&id=61028b8e&scoped=true"
import script from "./rankingList.vue?vue&type=script&lang=js"
export * from "./rankingList.vue?vue&type=script&lang=js"
import style0 from "./rankingList.vue?vue&type=style&index=0&id=61028b8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61028b8e",
  null
  
)

export default component.exports